<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import { EffectiveDatesResponse } from '@/application/shared/domain/EffectiveDatesResponse';
import { dateHelpers } from '@hfc/ui-core';
import { Field, ErrorMessage } from 'vee-validate';

const { fromTimestampToFormatted, getToday } = dateHelpers();

const props = defineProps<{
  effectiveDate?: number,
  options: Array<EffectiveDatesResponse>
}>();

interface EmitsInterface {
  (event: 'update:effectiveDate', value: number): void
}

const emits = defineEmits<EmitsInterface>();

const emitChange = async (): Promise<void> => {
  await nextTick();
  if (selectedOption.value) {
    emits('update:effectiveDate', selectedOption.value);
  }
};

const selectedOption = ref(props.effectiveDate || undefined);

onMounted(() => {
  const defaultOption = props.options.find((option) => option.default);
  const selectedOptionExists = props.effectiveDate && props.options.find((option) => option.date === selectedOption.value);

  if (!selectedOptionExists && defaultOption) {
    selectedOption.value = defaultOption.date;
    emitChange();
  }
});
</script>

<template>
  <label class="font-medium mb-1 text-sky-700 block">Desired effective date?</label>
  <div class="flex flex-col">
    <Field v-for="(option, index) in options" :key="index" v-model="selectedOption" :value="option.date" v-slot="{ field }" name="effective-date" type="radio" :rules="{required: true, max_date: getToday().getTime()}">
      <div class="flex flex-row">
        <input type="radio" class="h-4 w-4 mt-1" :id="`effective_date_${index}`" v-bind="field" @change="emitChange" />
        <label :for="`effective_date_${index}`" class="font-medium text-md text-sky-700 block ml-2 whitespace-nowrap">{{ fromTimestampToFormatted(option.date, 'MMMM DD, YYYY') }}</label>
      </div>
    </Field>
    <ErrorMessage name="effective-date" class="font-semibold text-red" />
  </div>
</template>
